import Loadable from '@react-loadable/revised';

const LoadableVideoDetail = Loadable({
    loader: () => import('./VideoDetail'),
    loading: () => null
});

export default LoadableVideoDetail;
